import AsyncStorage from '@react-native-async-storage/async-storage';
import { createLogger } from '@/lib/logger';

const log = createLogger('ONBOARD');

export type OnboardingFlags = {
  seenWelcome: boolean;
  seenDetailsStep: boolean;
  seenGymStep: boolean;
  seenStartJourney: boolean;
};

type FlagKey = 'seenWelcome' | 'seenDetailsStep' | 'seenGymStep' | 'seenStartJourney';

const DEFAULT_FLAGS: OnboardingFlags = {
  seenWelcome: false,
  seenDetailsStep: false,
  seenGymStep: false,
  seenStartJourney: false,
};

const flagStorageKey = (userId: string, key: FlagKey) => `onboarding:${userId}:${key}`;

export const getOnboardingFlags = async (userId: string): Promise<OnboardingFlags> => {
  try {
    const entries = await AsyncStorage.multiGet([
      flagStorageKey(userId, 'seenWelcome'),
      flagStorageKey(userId, 'seenDetailsStep'),
      flagStorageKey(userId, 'seenGymStep'),
      flagStorageKey(userId, 'seenStartJourney'),
    ]);

    const flagMap = Object.fromEntries(entries);

    return {
      seenWelcome: flagMap[flagStorageKey(userId, 'seenWelcome')] === 'true',
      seenDetailsStep: flagMap[flagStorageKey(userId, 'seenDetailsStep')] === 'true',
      seenGymStep: flagMap[flagStorageKey(userId, 'seenGymStep')] === 'true',
      seenStartJourney: flagMap[flagStorageKey(userId, 'seenStartJourney')] === 'true',
    };
  } catch (err) {
    log.warn('[ONBOARDING_FLAGS] Failed to load flags', err);
    return DEFAULT_FLAGS;
  }
};

export const markOnboardingFlag = async (userId: string, key: FlagKey) => {
  try {
    await AsyncStorage.setItem(flagStorageKey(userId, key), 'true');
  } catch (err) {
    log.warn('[ONBOARDING_FLAGS] Failed to set flag', key, err);
  }
};
